import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import styles from './faq.module.scss';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import { ctaTheme } from '../../utils/util';
import AccordionWrapper from '../accordion/accordionWrapper';

export default function Faq({ title, items, cta, expanded }) {
  const [ctaThemes, setCtaThemes] = useState(styles.redOutline);

  useEffect(() => {
    if (cta?.ctaTheme) setCtaThemes(ctaTheme(cta?.ctaTheme));
  }, [cta]);

  const data = items?.map((item, index) => {
    const key = `faq-${index}`;
    return (
      <AccordionWrapper
        key={key}
        id={key}
        itemType="https://schema.org/Question"
        itemProp="mainEntity"
        itemScope
        head={parse(
          `<div itemProp="name" data-testid='${item?.question}'>${item?.question}</div>`
        )}
        /* eslint-disable-next-line react/no-children-prop */
        body={parse(
          `<div itemScope={true} itemProp="acceptedAnswer" itemType="https://schema.org/Answer"><div itemProp="text" data-testid='${item.answer}'>${item.answer}</div></div>`
        )}
        expanded={expanded}
        borderBottom={index === items.length - 1}
      />
    );
  });

  return (
    <div className={styles.faq}>
      <div className={styles.questions}>
        {title && <div className={styles.title}>{title}</div>}
        <div
          className={styles.accordion}
          itemScope
          itemType="https://schema.org/FAQPage"
        >
          {data}
        </div>
      </div>
      {cta && (
        <div className={styles.cta}>
          <Button
            className={ctaThemes}
            aria-label={cta.label}
            variant="tertiary"
            type="button"
            fullWidth
            onClick={(e) => handleCTAClick(e, cta)}
            href={cta.link}
          >
            {cta.label}
          </Button>
        </div>
      )}
    </div>
  );
}

Faq.defaultProps = {
  title: '',
  items: [],
  cta: null,
  expanded: false,
};

Faq.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  expanded: PropTypes.bool,
};
